module.exports = __webpack_public_path__ + "assets/f1b40c901e4db2dbf45a765ae9e49153.mp3";